export const abilityPossibilityAuxiliaryQuestions = [
  {
    questionNumber: 1,
    questionText: "Can we eat in this area?",
    choices: {
      A: "Only in designated zones.",
      B: "I cleaned the microwave.",
      C: "The menu looks nice.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 구역에서 식사해도 될까요?",
      choices: {
        A: "지정된 구역에서만 가능합니다.",
        B: "전자레인지를 청소했습니다.",
        C: "메뉴가 좋아 보입니다.",
      },
    },
    explanation:
      "이 문제는 '가능 여부'를 묻는 조동사 can을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 식사 가능 여부에 대한 응답입니다. B는 전자레인지 청소에 관한 관련 없는 응답이고, C는 메뉴에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 2,
    questionText: "Would you like some more bread?",
    choices: {
      A: "My phone's charging.",
      B: "I went to the bakery.",
      C: "Yes, please.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "빵을 더 드시겠습니까?",
      choices: {
        A: "제 전화기가 충전 중입니다.",
        B: "제가 빵집에 갔었습니다.",
        C: "네, 감사합니다.",
      },
    },
    explanation:
      "이 문제는 '의향'을 묻는 조동사 would를 사용한 질문입니다. C는 질문에 대한 직접적인 대답으로 빵을 더 먹겠다는 의향을 나타냅니다. A는 전화기 충전에 관한 관련 없는 응답이고, B는 빵집 방문에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 3,
    questionText: "Will the office be open tomorrow?",
    choices: {
      A: "Yes, it's a regular workday.",
      B: "The windows are large.",
      C: "I ordered lunch.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "내일 사무실이 열려 있을까요?",
      choices: {
        A: "네, 정상 근무일입니다.",
        B: "창문이 큽니다.",
        C: "점심을 주문했습니다.",
      },
    },
    explanation:
      "이 문제는 '미래'에 대한 조동사 will을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 내일 사무실 운영 여부에 대한 응답입니다. B는 창문 크기에 관한 관련 없는 응답이고, C는 점심 주문에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 4,
    questionText: "Should I send her a reminder?",
    choices: {
      A: "No, she already confirmed.",
      B: "I like her handwriting.",
      C: "The printer's jammed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그녀에게 리마인더를 보내야 할까요?",
      choices: {
        A: "아니요, 그녀가 이미 확인했습니다.",
        B: "저는 그녀의 필체가 마음에 듭니다.",
        C: "프린터가 걸렸습니다.",
      },
    },
    explanation:
      "이 문제는 '조언/의무'를 나타내는 조동사 should를 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 리마인더 필요성에 대한 응답입니다. B는 필체에 관한 관련 없는 응답이고, C는 프린터 문제에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 5,
    questionText: "Can I see your ID, please?",
    choices: {
      A: "Of course, here it is.",
      B: "I left my umbrella.",
      C: "The door won't close.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "신분증을 볼 수 있을까요?",
      choices: {
        A: "물론이죠, 여기 있습니다.",
        B: "우산을 두고 왔습니다.",
        C: "문이 닫히지 않습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 나타내는 조동사 can을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 신분증 요청에 응하는 응답입니다. B는 우산에 관한 관련 없는 응답이고, C는 문 문제에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 6,
    questionText: "Would it be okay if I left early today?",
    choices: {
      A: "Sure, just let your team know.",
      B: "The lights are too bright.",
      C: "I prefer black coffee.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 일찍 퇴근해도 될까요?",
      choices: {
        A: "물론이죠, 팀에 알려주기만 하세요.",
        B: "조명이 너무 밝습니다.",
        C: "저는 블랙 커피를 선호합니다.",
      },
    },
    explanation:
      "이 문제는 '허가'를 구하는 조동사 would를 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 일찍 퇴근 요청에 대한 응답입니다. B는 조명 밝기에 관한 관련 없는 응답이고, C는 커피 선호도에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 7,
    questionText: "Should we cancel the reservation?",
    choices: {
      A: "Yes, there's been a change of plans.",
      B: "I watched a movie yesterday.",
      C: "My shoes are new.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "예약을 취소해야 할까요?",
      choices: {
        A: "네, 계획이 변경되었습니다.",
        B: "어제 영화를 봤습니다.",
        C: "제 신발은 새 것입니다.",
      },
    },
    explanation:
      "이 문제는 '조언/제안'을 나타내는 조동사 should를 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 예약 취소 여부에 대한 응답입니다. B는 영화 관람에 관한 관련 없는 응답이고, C는 신발에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 8,
    questionText: "Will someone be at the front desk after 6?",
    choices: {
      A: "I hung up the coat.",
      B: "Yes, we have evening staff.",
      C: "The carpet is red.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "6시 이후에 프론트 데스크에 누군가 있을까요?",
      choices: {
        A: "코트를 걸어두었습니다.",
        B: "네, 저녁 근무자가 있습니다.",
        C: "카펫은 빨간색입니다.",
      },
    },
    explanation:
      "이 문제는 '미래'에 대한 조동사 will을 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 6시 이후 프론트 데스크 직원 유무에 대한 응답입니다. A는 코트에 관한 관련 없는 응답이고, C는 카펫 색상에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 9,
    questionText: "Can I bring a guest to the event?",
    choices: {
      A: "The chairs are too soft.",
      B: "I believe that's allowed.",
      C: "I didn't sleep well.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "행사에 손님을 데려와도 될까요?",
      choices: {
        A: "의자가 너무 부드럽습니다.",
        B: "허용된다고 생각합니다.",
        C: "잘 자지 못했습니다.",
      },
    },
    explanation:
      "이 문제는 '허가'를 구하는 조동사 can을 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 손님 동반 가능 여부에 대한 응답입니다. A는 의자에 관한 관련 없는 응답이고, C는 수면에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 10,
    questionText: "Should I wait here or go inside?",
    choices: {
      A: "I borrowed a stapler.",
      B: "Just head in.",
      C: "The plant is artificial.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "여기서 기다려야 할까요, 아니면 안으로 들어가야 할까요?",
      choices: {
        A: "스테이플러를 빌렸습니다.",
        B: "그냥 들어가세요.",
        C: "그 식물은 인공적입니다.",
      },
    },
    explanation:
      "이 문제는 '조언/지시'를 구하는 조동사 should를 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 행동 방향에 대한 응답입니다. A는 스테이플러에 관한 관련 없는 응답이고, C는 식물에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 11,
    questionText: "Can I borrow your pen for a moment?",
    choices: {
      A: "No problem, here.",
      B: "I had cereal for breakfast.",
      C: "The floor was just mopped.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "잠시 펜을 빌려도 될까요?",
      choices: {
        A: "문제없어요, 여기 있습니다.",
        B: "아침에 시리얼을 먹었어요.",
        C: "바닥을 방금 닦았어요.",
      },
    },
    explanation:
      "이 문제는 '허가'를 구하는 조동사 can을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 펜을 빌려도 된다는 허락을 나타냅니다. B는 아침 식사에 관한 관련 없는 응답이고, C는 바닥 청소에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 12,
    questionText: "Will you be attending the meeting?",
    choices: {
      A: "Yes, I'm scheduled to go.",
      B: "I don't use headphones.",
      C: "It's made of plastic.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의에 참석하실 예정인가요?",
      choices: {
        A: "네, 참석하기로 예정되어 있습니다.",
        B: "저는 헤드폰을 사용하지 않습니다.",
        C: "그것은 플라스틱으로 만들어졌습니다.",
      },
    },
    explanation:
      "이 문제는 '미래 계획'에 대한 조동사 will을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 회의 참석 계획에 대한 응답입니다. B는 헤드폰 사용에 관한 관련 없는 응답이고, C는 재질에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 13,
    questionText: "Should I turn on the projector now?",
    choices: {
      A: "The windows were replaced.",
      B: "Not yet, we're still waiting.",
      C: "I fed the dog earlier.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "지금 프로젝터를 켜야 할까요?",
      choices: {
        A: "창문이 교체되었습니다.",
        B: "아직 아닙니다, 우리는 아직 기다리는 중입니다.",
        C: "저는 일찍 개에게 먹이를 주었습니다.",
      },
    },
    explanation:
      "이 문제는 '조언/지시'를 구하는 조동사 should를 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 프로젝터 작동 시점에 대한 응답입니다. A는 창문 교체에 관한 관련 없는 응답이고, C는 개 먹이에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 14,
    questionText: "Would you like help with that?",
    choices: {
      A: "I ordered from that restaurant.",
      B: "Yes, please.",
      C: "It's on the bottom shelf.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그것에 도움이 필요하신가요?",
      choices: {
        A: "저는 그 식당에서 주문했습니다.",
        B: "네, 부탁드립니다.",
        C: "그것은 아래 선반에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '의향'을 묻는 조동사 would를 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 도움을 받고 싶다는 의향을 나타냅니다. A는 식당 주문에 관한 관련 없는 응답이고, C는 물건 위치에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 15,
    questionText: "Can we leave our bags here?",
    choices: {
      A: "Sorry, that's not allowed.",
      B: "I take the train home.",
      C: "There are five of them.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "여기에 가방을 두고 가도 될까요?",
      choices: {
        A: "죄송합니다, 그것은 허용되지 않습니다.",
        B: "저는 기차를 타고 집에 갑니다.",
        C: "그것들은 다섯 개가 있습니다.",
      },
    },
    explanation:
      "이 문제는 '허가'를 구하는 조동사 can을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 가방을 두고 가는 것이 허용되지 않는다는 응답입니다. B는 귀가 방법에 관한 관련 없는 응답이고, C는 수량에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 16,
    questionText: "Should we review the report together?",
    choices: {
      A: "Sure, that sounds helpful.",
      B: "My laptop is charging.",
      C: "It's a sunny day.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "보고서를 함께 검토해야 할까요?",
      choices: {
        A: "물론이죠, 그게 도움이 될 것 같습니다.",
        B: "제 노트북이 충전 중입니다.",
        C: "오늘은 화창한 날입니다.",
      },
    },
    explanation:
      "이 문제는 '제안'을 하는 조동사 should를 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 보고서 함께 검토하자는 제안에 동의하는 응답입니다. B는 노트북 충전에 관한 관련 없는 응답이고, C는 날씨에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 17,
    questionText: "Will it be crowded this evening?",
    choices: {
      A: "Probably, it's Friday.",
      B: "I bought a candle.",
      C: "The ceiling is low.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 저녁에 사람이 많을까요?",
      choices: {
        A: "아마도요, 금요일이니까요.",
        B: "저는 양초를 샀습니다.",
        C: "천장이 낮습니다.",
      },
    },
    explanation:
      "이 문제는 '미래 예측'에 대한 조동사 will을 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 저녁 혼잡도에 대한 예측을 제공합니다. B는 양초 구매에 관한 관련 없는 응답이고, C는 천장 높이에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 18,
    questionText: "Can I pay with cash here?",
    choices: {
      A: "The weather was cold.",
      B: "Yes, we accept all methods.",
      C: "I have a red folder.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "여기서 현금으로 지불해도 될까요?",
      choices: {
        A: "날씨가 추웠습니다.",
        B: "네, 모든 결제 방법을 받습니다.",
        C: "저는 빨간색 폴더가 있습니다.",
      },
    },
    explanation:
      "이 문제는 '가능 여부'를 묻는 조동사 can을 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 현금 결제 가능 여부에 대한 응답입니다. A는 날씨에 관한 관련 없는 응답이고, C는 폴더에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 19,
    questionText: "Would it be all right to record the session?",
    choices: {
      A: "I cleaned the microwave.",
      B: "Sure, just don't share it online.",
      C: "The chairs are heavy.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "세션을 녹화해도 괜찮을까요?",
      choices: {
        A: "전자레인지를 청소했습니다.",
        B: "물론이죠, 단 온라인에 공유하지 마세요.",
        C: "의자가 무겁습니다.",
      },
    },
    explanation:
      "이 문제는 '허가'를 구하는 조동사 would를 사용한 질문입니다. B는 질문에 대한 직접적인 대답으로 세션 녹화 허가에 대한 응답입니다. A는 전자레인지 청소에 관한 관련 없는 응답이고, C는 의자 무게에 관한 관련 없는 응답입니다.",
  },
  {
    questionNumber: 20,
    questionText: "Should I schedule the delivery for tomorrow?",
    choices: {
      A: "That would be perfect.",
      B: "I'm allergic to cats.",
      C: "It has three buttons.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "내일로 배송을 예약해야 할까요?",
      choices: {
        A: "그게 완벽할 것 같습니다.",
        B: "저는 고양이에 알레르기가 있습니다.",
        C: "그것은 버튼이 세 개 있습니다.",
      },
    },
    explanation:
      "이 문제는 '조언/제안'을 구하는 조동사 should를 사용한 질문입니다. A는 질문에 대한 직접적인 대답으로 내일 배송 예약에 동의하는 응답입니다. B는 고양이 알레르기에 관한 관련 없는 응답이고, C는 버튼 개수에 관한 관련 없는 응답입니다.",
  },
];
